import { extendObservable } from "mobx";

interface MessageProperties {
  [code: string]: string;
}

export default class MessageModel {
  public cacheSeconds!: number;
  public invalidPrefix?: string;
  public invalidSuffix?: string;
  public properties!: MessageProperties;

  public constructor(data) {
    extendObservable(this, data);
  }
}
